export enum SortByOrderingEnum {
	Asc = 'ASC',
	Desc = 'DESC',
}

export enum ReceivedRequestSortBy {
	CreatedAt = 'CREATED_AT',
	UpdatedAt = 'UPDATED_AT',
	EmissionValue = 'EMISSION_VALUE',
	ProductRequestStatus = 'PRODUCT_REQUEST_STATUS',
	ProductName = 'PRODUCT_NAME',
	ProductUnit = 'PRODUCT_UNIT',
}

export enum ProductEmissionRequestSortBy {
	CreatedAt = 'CREATED_AT',
	UpdatedAt = 'UPDATED_AT',
	ReferenceNum = 'INTERNAL_REFERENCE',
	EmissionValue = 'EMISSION_VALUE',
}

export enum TemplateSortBy {
	CreatedAt = 'CREATED_AT',
	UpdatedAt = 'UPDATED_AT',
	EmissionValue = 'EMISSION_VALUE',
}

export enum SupplierSortBy {
	Default = 'DEFAULT',
	ProductsConnected = 'PRODUCTS_CONNECTED',
}
export enum OrganizationInvitationSentSortBy {
	CreatedAt = 'CREATED_AT',
}

export enum QueryKey {
	GetAggregatedProductRequestAgeOverview,
	GetAggregatedProductRequestDataOverview,
	GetCurrentUser,
	GetCustomers,
	GetEmissionDataRequest,
	GetEmissionRequestDetails,
	GetEmissionRequestProductDetails,
	GetInvitedSuppliers,
	GetOwnOrganization,
	GetPurchasedProducts,
	GetReceivedProductRequests,
	GetSBTISupplierStatistics,
	GetSBTItarget,
	GetSoldProducts,
	GetSupplier,
	GetSuppliers,
	GetTemplateDetails,
	ListAttachments,
	ListPendingUserInvites,
	ListReceivedInvitations,
	ListSentInvitations,
	ListSupplier,
	ListTemplates,
	ListUsers,
	ListAccessRequests,
	GetCorporateDataRequests,
	GetCorporateDataRequest,
	GetCorporateDataRequestYears,
	GetCorporateData,
	PostLlmChat,
	GetFormTemplates,
	GetFormTemplateVersions,
	GetSupplyChainPartners,
	GetSupplyChainPartner,
	GetConnectedOrganizations,
	GetReceivedShareCredentials,
	ListConnectedOrganizationFootprints,
	GetCatenaXCredentials,
	GetCatenaXProductPartners,
	GetPactOutboundCredentials,
}
